export const SET_SHOW_MAIN_MENU = 'app/core/SET_SHOW_MAIN_MENU';

export const ENABLE_MAINTENANCE_MODE = 'app/core/ENABLE_MAINTENANCE_MODE';

export const SET_FEATURE_FLAG = 'app/core/SET_FEATURE_FLAG';
